// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add to Header.module.css */

.Header_notificationBadge__IYNBt {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff4b4b;
  color: white;
  border-radius: 50%;
  min-width: 18px;
  height: 18px;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 101;
}

.Header_dropdownWrapper__SPxbN {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  z-index: 1000;
}

.Header_notificationDropdown__Zor3Q {
  width: 320px;
  max-height: 400px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.Header_notificationHeader__ztvc7 {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Header_notificationHeader__ztvc7 h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.Header_notificationActions__jgYW7 {
  display: flex;
  gap: 8px;
}

.Header_actionBtn__EC0Ja {
  background: none;
  border: none;
  color: #1b5bff;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}

.Header_actionBtn__EC0Ja:hover {
  background: #f0f4ff;
}

.Header_notificationList__5L\\+ks {
  overflow-y: auto;
  max-height: 350px;
}

.Header_emptyNotifications__9uvO0 {
  padding: 32px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.Header_notificationItem__1m3UC {
  padding: 12px 16px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  display: flex;
  gap: 12px;
  transition: background 0.2s;
}

.Header_notificationItem__1m3UC:hover {
  background: #f8f9fa;
}

.Header_notificationItem__1m3UC.Header_unread__-eVfp {
  background: #f0f7ff;
}

.Header_notificationItem__1m3UC.Header_unread__-eVfp:hover {
  background: #e5f0ff;
}

.Header_notificationIcon__4kX1Z {
  font-size: 20px;
  min-width: 24px;
}

.Header_notificationContent__z-h6O {
  flex: 1 1;
  position: relative;
}

.Header_notificationMessage__gbOEE {
  font-size: 13px;
  color: #333;
  margin-bottom: 4px;
  padding-right: 16px;
}

.Header_notificationTime__CwiWF {
  font-size: 11px;
  color: #999;
}

.Header_unreadDot__nP4dE {
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 8px;
  background-color: #1b5bff;
  border-radius: 50%;
}

.Header_headerWrap__861jp {
  height: 100%;
}
.Header_topbar__FHorL {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */
  padding: 0px 100px;
  height: 100%;
  background: var(--bg-primary);
}

.Header_profileHelp__d49RK {
  display: flex;
  gap: 20px;
  align-items: center;
}
.Header_logo__9GHkh {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.Header_logoImg__Yssg7 {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: #f5f5f5; */
}

.Header_logoImg__Yssg7 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.Header_logo__9GHkh h2 {
  font-size: 24px;
  font-weight: 600;
  color: var(--heading);
  margin-bottom: 0px;
}
.Header_upgrade__iiaN\\+ {
  position: relative;
  overflow: hidden;
  padding: 6px 10px;
  background: var(--gradient-success);
  border-radius: 6px;
  cursor: pointer;
  color: white;
}

.Header_upgrade__iiaN\\+::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 40%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  filter: blur(8px);
  transform: skewX(-20deg);
  transition: left 2.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.Header_upgrade__iiaN\\+:hover::before {
  left: 150%;
}

.Header_upgradeBtn__p67OU {
  font-size: 0.8rem;
  border: none;
  font-weight: 600;
  background-color: transparent;
  cursor: pointer;
}
.Header_sageText__VGPaK {
  color: #ff9a00;
}

.Header_ionText__cTwXB {
  color: #41ab5d;
}
@media (max-width: 768px) {
  .Header_topbar__FHorL {
    padding: 0px 20px;
  }
}
@media (max-width: 368px) {
  .Header_topbar__FHorL {
    padding: 10px 20px;
  }
  .Header_logoImg__Yssg7 {
    width: 36px;
    height: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Header/Header.module.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uDAAuD;EACvD,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Add to Header.module.css */\n\n.notificationBadge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background-color: #ff4b4b;\n  color: white;\n  border-radius: 50%;\n  min-width: 18px;\n  height: 18px;\n  font-size: 11px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  border: 2px solid white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  z-index: 101;\n}\n\n.dropdownWrapper {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  z-index: 1000;\n}\n\n.notificationDropdown {\n  width: 320px;\n  max-height: 400px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.notificationHeader {\n  padding: 12px 16px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.notificationHeader h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.notificationActions {\n  display: flex;\n  gap: 8px;\n}\n\n.actionBtn {\n  background: none;\n  border: none;\n  color: #1b5bff;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.actionBtn:hover {\n  background: #f0f4ff;\n}\n\n.notificationList {\n  overflow-y: auto;\n  max-height: 350px;\n}\n\n.emptyNotifications {\n  padding: 32px 16px;\n  text-align: center;\n  color: #999;\n  font-size: 14px;\n}\n\n.notificationItem {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f5f5f5;\n  cursor: pointer;\n  display: flex;\n  gap: 12px;\n  transition: background 0.2s;\n}\n\n.notificationItem:hover {\n  background: #f8f9fa;\n}\n\n.notificationItem.unread {\n  background: #f0f7ff;\n}\n\n.notificationItem.unread:hover {\n  background: #e5f0ff;\n}\n\n.notificationIcon {\n  font-size: 20px;\n  min-width: 24px;\n}\n\n.notificationContent {\n  flex: 1;\n  position: relative;\n}\n\n.notificationMessage {\n  font-size: 13px;\n  color: #333;\n  margin-bottom: 4px;\n  padding-right: 16px;\n}\n\n.notificationTime {\n  font-size: 11px;\n  color: #999;\n}\n\n.unreadDot {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 8px;\n  background-color: #1b5bff;\n  border-radius: 50%;\n}\n\n.headerWrap {\n  height: 100%;\n}\n.topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */\n  padding: 0px 100px;\n  height: 100%;\n  background: var(--bg-primary);\n}\n\n.profileHelp {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n.logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.logoImg {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* background-color: #f5f5f5; */\n}\n\n.logoImg img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.logo h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--heading);\n  margin-bottom: 0px;\n}\n.upgrade {\n  position: relative;\n  overflow: hidden;\n  padding: 6px 10px;\n  background: var(--gradient-success);\n  border-radius: 6px;\n  cursor: pointer;\n  color: white;\n}\n\n.upgrade::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 40%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.6);\n  filter: blur(8px);\n  transform: skewX(-20deg);\n  transition: left 2.5s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.upgrade:hover::before {\n  left: 150%;\n}\n\n.upgradeBtn {\n  font-size: 0.8rem;\n  border: none;\n  font-weight: 600;\n  background-color: transparent;\n  cursor: pointer;\n}\n.sageText {\n  color: #ff9a00;\n}\n\n.ionText {\n  color: #41ab5d;\n}\n@media (max-width: 768px) {\n  .topbar {\n    padding: 0px 20px;\n  }\n}\n@media (max-width: 368px) {\n  .topbar {\n    padding: 10px 20px;\n  }\n  .logoImg {\n    width: 36px;\n    height: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationBadge": `Header_notificationBadge__IYNBt`,
	"dropdownWrapper": `Header_dropdownWrapper__SPxbN`,
	"notificationDropdown": `Header_notificationDropdown__Zor3Q`,
	"notificationHeader": `Header_notificationHeader__ztvc7`,
	"notificationActions": `Header_notificationActions__jgYW7`,
	"actionBtn": `Header_actionBtn__EC0Ja`,
	"notificationList": `Header_notificationList__5L+ks`,
	"emptyNotifications": `Header_emptyNotifications__9uvO0`,
	"notificationItem": `Header_notificationItem__1m3UC`,
	"unread": `Header_unread__-eVfp`,
	"notificationIcon": `Header_notificationIcon__4kX1Z`,
	"notificationContent": `Header_notificationContent__z-h6O`,
	"notificationMessage": `Header_notificationMessage__gbOEE`,
	"notificationTime": `Header_notificationTime__CwiWF`,
	"unreadDot": `Header_unreadDot__nP4dE`,
	"headerWrap": `Header_headerWrap__861jp`,
	"topbar": `Header_topbar__FHorL`,
	"profileHelp": `Header_profileHelp__d49RK`,
	"logo": `Header_logo__9GHkh`,
	"logoImg": `Header_logoImg__Yssg7`,
	"upgrade": `Header_upgrade__iiaN+`,
	"upgradeBtn": `Header_upgradeBtn__p67OU`,
	"sageText": `Header_sageText__VGPaK`,
	"ionText": `Header_ionText__cTwXB`
};
export default ___CSS_LOADER_EXPORT___;
